import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import {
  useSelector,
  useDispatch,
} from 'react-redux';
import makeStyles from '@mui/styles/makeStyles';
import {
  Alert,
  Container,
} from '@mui/material';
import { useAuth0 } from '@auth0/auth0-react';
import { logoutAction } from './logout-slice';
import { IQLoadingSpinner } from '@gannettdigital/shared-react-components';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  spinnerClass: {
    height: 150,
    width: 150,
  },
}));

const hasLocaliqSession = () => {
  if (typeof document === 'undefined') return false;
  const match = document.cookie.match(/(?:^|;\s*)localiq_session_expiration=([^;]+)/);
  // We only need to know that a session existed, which is indicated by the cookie match.
  return !!match;
};

export default function LogoutPage() {
  const dispatch = useDispatch();
  const classes = useStyles();
  const {
    isAuthenticated, isLoading, logout,
  } = useAuth0();
  const logoutError = useSelector((state) => state.error.logoutUserError);
  const { logoutSuccess } = useSelector((state) => state.logout);

  useEffect(() => {
    const performLogout = async () => {
      if (hasLocaliqSession()) {
        dispatch(logoutAction({ fromAuth0: false }));
      } else {
        dispatch(logoutAction({ fromAuth0: true }));
      }
    };
    if (!isLoading && !logoutSuccess) { performLogout(); }
  }, [dispatch, isLoading, logoutSuccess, hasLocaliqSession]);

  useEffect(() => {
    if (logoutSuccess && isAuthenticated && !hasLocaliqSession()) {
      logout({ logoutParams: { returnTo: window.location.origin + '/login-auth' } });
    }
  }, [logoutSuccess, isAuthenticated, logout, hasLocaliqSession]);

  return (
    <>
      <Helmet>
        <title>Logging Out | LocaliQ</title>
      </Helmet>
      <Container className={classes.root}>
        {logoutError && (
          <Alert severity="error">An unknown error occurred when signing out. Please refresh and try again.</Alert>
        )}
        {!logoutError && (
          <IQLoadingSpinner />
        )}
      </Container>
    </>
  );
}
